(function() {
  document.addEventListener('DOMContentLoaded', function() {
    initializeProductTypeFilter();
  });

  function initializeProductTypeFilter() {
    const productGrid = document.querySelector('.collection-products');
    const typeButtons = document.querySelectorAll('.type-btn');

    if (!productGrid || !typeButtons.length) return;

    typeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        // Remove active class from all buttons
        typeButtons.forEach(btn => btn.classList.remove('active'));
        
        // Add active class to clicked button
        button.classList.add('active');
        
        // Filter products
        const selectedType = button.dataset.type;
        filterProductsByType(selectedType, productGrid);
        updateProductCount(productGrid);
      });
    });
  }

  function filterProductsByType(selectedType, productGrid) {
    const products = productGrid.querySelectorAll('.collection-product');
    
    products.forEach(product => {
      const productType = product.dataset.type;
      if (selectedType === 'all' || productType === selectedType) {
        product.style.display = '';
      } else {
        product.style.display = 'none';
      }
    });
  }

  function updateProductCount(productGrid) {
    const countElement = document.querySelector('.product-count');
    if (!countElement) return;

    const visibleProducts = Array.from(productGrid.children)
      .filter(product => product.style.display !== 'none').length;
    
    countElement.textContent = `${visibleProducts} products`;
  }
})();